import { Divider } from '@chakra-ui/react';
import React from 'react';

import { DataPipelineNavItem } from '~/backup/shared/components/DataPipelineNavItem';
import { Icon } from '~/packages/common-frontend/components/icons';
import {
  GlobalNav,
  GlobalNavRouterLinkItem,
} from '~/packages/common-frontend/layout';

/**
 * Lender portal sidebar. Portfolio + Strats are the daily path and stay primary;
 * Data Pipeline (an audit / config surface) and the Assistant sit below a divider
 * at `size="sm"` — the same secondary-group treatment the core dashboard uses for
 * Data Pipeline / Implementations / Events Log.
 */
export const BackupLenderGlobalNav = ({
  isFixed = true,
}: {
  isFixed?: boolean;
}): React.ReactElement => {
  return (
    <GlobalNav isFixed={isFixed} offsetHeaderCount={1}>
      <GlobalNavRouterLinkItem
        to="/portfolio"
        label="Portfolio"
        icon={<Icon icon="house" />}
      />
      <GlobalNavRouterLinkItem
        to="/strats"
        label="Strats"
        icon={<Icon icon="chart-mixed" />}
      />

      <Divider margin="0.5rem 0" width="auto" />

      <DataPipelineNavItem size="sm" />
      <GlobalNavRouterLinkItem
        to="/agent"
        label="Assistant"
        icon={<Icon icon="robot" />}
        size="sm"
      />
    </GlobalNav>
  );
};
